<template>
    <div v-if="view">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <h4 style="font-weight:100" class="font-en mt-0 mb-0">
                    <b-link
                        :to="{
                            name: 'Teaching record'
                        }"
                        class="mr-3"
                    >
                        <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
                    </b-link>
                    &nbsp;Teaching records
                </h4>
                <small class="mt-0 ml-5">Select teaching record details and upload the reference file.</small>
                <b-card class="mt-3">
                    <b-card-body>
                        <b-form @submit.prevent="sendFormTeaching" class="mt-0">
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label style="color:#66615b;" class="font-en">Term year <span class="text-danger">*</span></label>
                                </b-col>
                                <b-col sm="9">
                                    <!-- <b-form-select @change="selectSectionTerm"  v-model="formData.term" :options="Optionterm"></b-form-select> -->
                                    <Select2
                                        @change="selectSectionTerm"  v-model="formData.term" :options="Optionterm"
                                        :settings="{ placeholder:'Please select term',width:'100%' }"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label style="color:#66615b;" class="font-en">Course <span class="text-danger">*</span></label>
                                </b-col>
                                <b-col sm="9">
                                    <!--  
                                        <b-form-group v-if="msgErrorOption === ''" description="Please contact : Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208 If you could not find needed course.">
                                            <b-form-select :disabled="closeCode" @change="selectSection"  v-model="formData.course" :options="codes"></b-form-select>
                                        </b-form-group>
                                    -->
                                    <div v-if="msgErrorOption === ''">
                                        <Select2
                                            :disabled="closeCode" @change="selectSection"  v-model="formData.course" :options="codes"
                                            :settings="{ placeholder:'Please select course',width:'100%' }"
                                        />
                                        <small>Please contact : Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208 If you could not find needed course.</small>
                                    </div>
                                    <b-form-group v-else>
                                        <b-form-input
                                            v-model="formData.course"
                                            class="font-en"
                                            size="small"
                                            type="text"
                                            placeholder="ex. ICCS101"
                                            autocomplete="off" trim
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="my-3">
                                <b-col sm="3">
                                    <label style="color:#66615b;" class="font-en">Section <span class="text-danger">*</span></label>
                                </b-col>
                                <b-col sm="9">
                                    <Select2
                                        v-model="formData.section"
                                        :options="OptionSelection"
                                        :settings="{ placeholder:'Please select section',width:'100%' }"
                                        :disabled="disable"
                                    />
                                    <!-- <b-form-select :disabled="disable" v-model="formData.section" :options="OptionSelection"></b-form-select> -->
                                </b-col>
                            </b-row>
                            <b-row class="my-3">
                                <b-col sm="3">
                                    <label style="color:#66615b;" class="font-en">Teaching period <span class="text-danger">*</span></label>
                                </b-col>
                                <b-col sm="9">
                                    <Select2
                                        v-model="formData.week"
                                        :options="round"
                                        :settings="{ placeholder:'Please select round',width:'100%' }"
                                    />
                                    <!-- <b-form-select v-model="formData.week" :options="round"></b-form-select> -->
                                </b-col>
                            </b-row>
                            <b-row class="my-3">
                                <b-col sm="3">
                                    <label style="color:#66615b;" class="font-en">Upload <span class="text-danger">*</span></label>
                                </b-col>
                                <b-col sm="9">
                                    <!-- .jpg, .png, .pdf, .xlsx, .csv or .zip. if you have multiple files, please zip them and upload. | image/jpeg, image/png, application/pdf, application/zip , .rar, .7zip , .csv , application/vnd.openxmlformats-officedocument.spreadsheetml.sheet -->
                                    <b-form-group description="Teaching record file can be screenshots of meeting logs or meeting screens. File types that can be uploaded are .pdf">
                                        <b-form-file
                                            ref="pictureInput"
                                            v-model="formData.file"
                                            :state="checkFileType(formData.file)"
                                            placeholder="Select teaching record file"
                                            drop-placeholder="Drop file here..."
                                            accept="application/pdf"
                                        ></b-form-file>
                                    </b-form-group>
                                    <div class="mt-3">Selected file: <span v-html="msgFile"></span></div>
                                </b-col>
                            </b-row>
                            <b-row class="my-2">
                                <b-col sm="3"></b-col>
                                <b-col sm="9">
                                    <b-button
                                        :disabled="!isForm"
                                        type="submit" 
                                        size="sm"
                                        block variant="success"
                                    ><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                                    <b-alert v-if="msgError !== ''"  class="mt-2" show variant="warning">Error : {{ msgError }} </b-alert>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Rubik', sans-serif; }
</style>

<style>
    .select2-container .select2-selection--single {
        box-sizing: border-box;
        cursor: pointer;
        display: block;
        height: 40px;
        user-select: none;
        -webkit-user-select: none;
    }
    .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #444;
        line-height: 38px;
        font-size: 16px;
    }
    .select2-container--default .select2-selection--single {
        background-color: #fff;
        border: 1px solid #ced4d9;
        border-radius: 4px;
    }
</style>

<script>
    import Select2 from 'v-select2-component';
    import datePicker from 'vue-bootstrap-datetimepicker'
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
    const formTeaching = {
        term:'',
        course:'',
        section:'',
        week:'',
        file:null,
    }
    export default {
        components: {
            datePicker,
            Select2
        },
        data() {
            return {
                view:false,
                msgFile:'',
                msgError:'',
                msgErrorOption:'',
                optionsPicker: {
                    format: 'YYYY-MM-DD h:mm:ss',
                    useCurrent: false,
                },
                Optionterm:[],
                dataCode: [],
                codes: [{id: '', text: 'Please select course' , disabled: true}],
                disable: true,
                OptionValue:[],
                OptionSelection:[{id: '', text: 'Please select section' , disabled: true}],
                round:[],
                formData: Object.assign({}, formTeaching),
                OptionValueTerm:[],
                closeCode:true
            }
        },
        computed: {
            isForm(){
                return this.formData.course !== '' && this.formData.section !== '' && this.formData.week !== '' && this.formData.file !== null;
            }
        },
        mounted(){
            this.callTerm()
            this.checkMsgWhoAmi()
            this.callListPeriods()
            // this.callCode()
        },
        methods: {
            checkMsgWhoAmi(){
                var count = 0
                var arr = ['faculty']
                // console.log(this.$store.state.permit.RulesUser.permissions.includes('TeamDev:admin'))
                for (let index = 0; index < this.$store.state.permit.RulesUser.roles.length; index++) {
                    // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
                    if(arr.includes(this.$store.state.permit.RulesUser.roles[index]) || this.$store.state.permit.RulesUser.permissions.includes('TeamDev:admin')){
                        count++
                    }
                }
                // console.log(count)
                if(count == 0){
                    this.$router.push("/").catch(err => {})
                }else{
                    this.view = true
                }
            },
            async callListPeriods(){
                const res = await this.$http.get('/teaching/note_period/')
                this.round = res.data.map( item => {
                    return {
                        'id':item.id,
                        'text':item.period+' ( '+item.type_around+' )',
                    }
                })
                this.round.sort((a, b) =>{ return b.id - a.id; });
                this.round.push({id: '', text: 'Please select teaching period' , disabled: true})
            },
            async callTerm(){
                this.Optionterm = []
                try {
                    const res = await this.$http.get('/teaching/course/term_year/')
                    // console.log(res.data)
                    this.Optionterm = res.data.map(item => {
                        return { 
                            'id': `${item.term_year}`,
                            'text': `${item.term_year}`,
                        }
                    })
                    this.Optionterm.sort(function(a, b) {
                        var nameA = a.id.toUpperCase();
                        var nameB = b.id.toUpperCase();
                        if (nameA > nameB) { return -1; }
                        if (nameA < nameB) { return 1; }
                        return 0;
                    });
                    this.Optionterm.push({id: '', text: 'Please select Term year' , disabled: true})
                } catch (error) {}
            },
            async callCode(TermYearValue){
                this.codes = []
                this.dataCode = []
                try {
                    const res = await this.$http.get(`/teaching/course/?term_year=${TermYearValue}`)
                    if(res.status === 200){
                        // code
                        this.codes = res.data.map(item => {
                            return { 
                                'id': `${item.subject}`,
                                'text': `${item.subject}`,
                            }
                        })
                        this.codes.sort(function(a, b) {
                            var nameA = a.id.toUpperCase();
                            var nameB = b.id.toUpperCase();
                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            return 0;
                        });
                        this.codes.push({id: '', text: 'Please select course' , disabled: true})
                        //  alldata
                        this.dataCode = res.data.map(itemData => {
                            return { 
                                'section': itemData.section,
                                'subject': `${itemData.subject}`,
                                'term_year': itemData.term_year,
                            }
                        })
                    }
                } catch (error) {
                    this.msgErrorOption = 'error'
                    this.codes.push({id: '', text: 'empty course' , disabled: true})
                }
            },
            checkFileType(valFile){
                if(valFile !== null){
                    if(valFile.type !== 'application/pdf'){
                        this.formData.file = null
                        this.msgFile = '<span class="text-danger">.pdf file only.</span>'
                        return false
                    }else{ 
                        this.msgFile = `<span class="text-success">${this.formData.file.name}</span>`
                    }
                }else{
                    return null
                }
            },
            async sendFormTeaching(e){
                const sendData = new FormData()
                sendData.append('term', this.formData.term)
                sendData.append('course', this.formData.course)
                sendData.append('section', this.formData.section)
                sendData.append('around', this.formData.week)
                sendData.append('upload_file', this.formData.file)
                try {
                    const response = await this.$http.post('/teaching/note/add/',
                        sendData,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.formData = Object.assign({}, formTeaching)
                        this.$router.replace('/teaching')
                    }else{
                        throw { response }
                    }
                } catch (error) {
                    this.msgError = 'File size exceeds 10 MB or Your session has time out. Please login and upload again.'
                }
            },
            selectSectionTerm(){
                this.closeCode = true
                this.formData.course = ''
                this.codes = []
                this.callCode(this.formData.term)
                this.closeCode = false
            },
            selectSection(){
                this.formData.section = ''
                this.OptionValue = []
                this.OptionSelection = []
                this.OptionValue = this.dataCode.filter( item => {
                    return item.subject === this.formData.course
                }).map(itemData => {
                    return { 
                        'value': itemData.section,
                    }
                })
                this.OptionSelection =  this.OptionValue[0].value.map(itemOption => {
                    return { 
                        'id': itemOption,
                        'text': `${itemOption}`,
                    }
                })
                this.OptionSelection.sort((a, b) =>{ return a.id - b.id; }).push({id: '', text: 'Please select section' , disabled: true})
                this.disable = false
            }
        }
    }
</script>